<style lang="scss" scoped>
    .helpful-hints {
        a {
            cursor: pointer;
        }
    }
</style>

<template>
    <div class="page-container">
        <section-collapse accordion="certification-accordion" id="certification-training-video">
            <div slot="title">Review Consultant Training Overview</div>
            <div slot="collapsed-content">
                Reviewing the Consultant Training Overview is the first step in becoming a certified Go NAPSACC Be Active Kids 
                trainer. Review the slides and notes to learn more about the history of Be Active Kids, 
                it’s integration with Go NAPSACC, and how you can use the tools to help child care 
                providers meet their physical activity goals.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_consultant_training_overview.pptx'">View Slides</a>
            </div>
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-training-manual">
            <div slot="title">Review Consultant Manual</div>
            <div slot="collapsed-content">
                The Consultant Manual provides all of the resources you will need to hold a successful
                Build the Skills with Be Active Kids training. Review the Consultant Manual thoroughly
                as you are preparing to become a certified Go NAPSACC Be Active Kids trainer.
                <br/>
                <a :href="$basePath + '/be-active-kids/bts_consultant_manual.pdf'" target="_blank">Consultant Manual</a>
            </div>
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-movement-guide">
            <div slot="title">Review Be Active Kids Movement Guide</div>
            <div slot="collapsed-content">
                The Be Active Kids Movement Guide is at the core of the Build the Skills with Be Active Kids training. This 
                evidence-informed resource provides over 85 developmentally appropriate activities 
                focused on practicing fundamental motor skills and movement concepts for children birth to 
                five. Review the Movement Guide to become familiar with its layout and how it will be used 
                in your Build the Skills with Be Active Kids trainings.
                <br/>
                <a :href="$basePath + '/be-active-kids/bak_movement_guide.pdf'" target="_blank">Be Active Kids Movement Guide</a>
            </div>
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-training-slides">
            <div slot="title">Review Provider Training</div>
            <div slot="collapsed-content">
                The Provider Training includes a pdf of the slides and script that you will need to conduct a Build the Skills with Be Active Kids training with child care providers. Review this document to become familiar with the training content and learn how you can modify based off your chosen delivery method (virtual, in-person, or hybrid). In Step 2 you will be provided a PowerPoint  file of the Provider Training slides and a separate pdf file of the Provider Training Script.
                <br />
                <a :href="$basePath + '/be-active-kids/bts_provider_training_slides.pdf'" target="_blank">Provider Training</a>
            </div> 
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-quiz">
            <div slot="title">Complete Consultant Certification Quiz</div>

            <div slot="collapsed-content">
                Completing the quiz is the final step to becoming a certified Go NAPSACC Be Active Kids trainer. 
                You may reference any of the files above as you are completing the quiz. 
                You must get 8 out of 10 questions correct to successfully pass the quiz and download your certificate.
                <br/>
                <a href="#" @click="$emit('select-content', 'build-the-skills-assessment');">Open Consultant Quiz</a>
            </div>
        </section-collapse>

        <section-collapse accordion="certification-accordion" id="certification-certificate">
            <div slot="title">Download Certificate of Completion</div>
            <div slot="collapsed-content">
                <template v-if="!enableCertificate">
                    Once you have successfully completed your Certification Quiz, you may download your certificate of completion.
                </template>
                <template v-else>
                    Congratulations on becoming a certified Go NAPSACC Be Active Kids trainer! You are now ready to move on to Step 2 and start leading Build the Skills with Be Active Kids provider training sessions.
                    <br />
                    <a href="#" @click="$emit('select-content', 'build-the-skills-certificate');">Open Completion Certificate</a>
                </template>
            </div>
        </section-collapse>
    </div>
</template>

<script>
    export default {
        props: {
            enableCertificate: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        components: {
        },
        data() {
            return {
            }
        },
        methods: {},
        $basePath() {
            return window.basePath;
        }
    }
</script>